import React from 'react';
import PicListsInputFields from './PicListsInputFields';

// This Input Bar component is used to wrap 1 to 2 input fields 
// The props required by InputFields component is passed to 
// this component so they can be be propagated to the InputFields component
// Note: only way I can get pic-lists-inputbar to expand 100% of the outter container was to 
// provide a wrapper with an inline style, setting width to 100%;
export const PicListsInputBar = (props) => {
    return (
        <div style={{width: '100%'}}>
            <div className="pic-lists-inputbar">
                <div>
                    <PicListsInputFields 
                        placeholder1={props.placeholder1}
                        placeholder2={props.placeholder2}
                        inputValue1={props.inputValue1}
                        inputValue2={props.inputValue2}
                        onChangeValue1={props.onChangeValue1}
                        onChangeValue2={props.onChangeValue2}
                        parentOnSubmit={props.parentOnSubmit}
                    />
                </div>
            </div>
        </div>
    )
}






// WEBPACK FOOTER //
// ./src/components/PicListsInputBar.js